import { render, staticRenderFns } from "./DadosDocumentoItem.vue?vue&type=template&id=1dc092b0&"
import script from "./DadosDocumentoItem.vue?vue&type=script&lang=js&"
export * from "./DadosDocumentoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports